class ScrollSlider extends HTMLElement {
  constructor() {
    super();
    this.mount();
  }

  mount() {
    document
      .querySelectorAll(".text-columns-icons.scroll-slide")
      .forEach((section) => {
        const container = section.querySelector(".grid");
        const scrollbar = section.querySelector(".custom-scrollbar");
        const thumb = section.querySelector(".custom-scrollbar-thumb");

        container.addEventListener("scroll", () =>
          this.updateThumb(container, scrollbar, thumb)
        );

        let isDragging = false;
        let startX;
        let startScrollLeft;

        thumb.addEventListener("mousedown", (e) => {
          isDragging = true;
          startX = e.pageX - thumb.offsetLeft;
          startScrollLeft = container.scrollLeft;
          document.body.style.userSelect = "none";
        });

        window.addEventListener("mouseup", () => {
          isDragging = false;
          document.body.style.userSelect = "auto";
        });

        window.addEventListener("mousemove", (e) => {
          if (!isDragging) return;
          console.log("e", e);

          const scrollbarWidth = scrollbar.clientWidth;
          const thumbWidth = thumb.clientWidth;

          let x = e.pageX - scrollbar.getBoundingClientRect().left - startX;
          x = Math.max(0, Math.min(x, scrollbarWidth - thumbWidth));

          const scrollableWidth = container.scrollWidth - container.clientWidth;
          const scrollLeft =
            (x / (scrollbarWidth - thumbWidth)) * scrollableWidth;

          container.scrollLeft = scrollLeft;
        });

        window.addEventListener("resize", () =>
          this.updateThumb(container, scrollbar, thumb)
        );
        this.updateThumb(container, scrollbar, thumb);
      });
  }

  updateThumb(container, scrollbar, thumb) {

    const containerWidth = container.clientWidth;
    const contentWidth = container.scrollWidth;
    const scrollLeft = container.scrollLeft;

    if (contentWidth <= containerWidth) {
      scrollbar.style.display = "none";
      return;
    } else {
      scrollbar.style.display = "block";
    }

    const scrollbarWidth = scrollbar.clientWidth;
    const thumbWidth = Math.max(
      (containerWidth / contentWidth) * scrollbarWidth,
      30
    );
    thumb.style.width = thumbWidth + "px";
    const maxThumbLeft = scrollbarWidth - thumbWidth;
    const thumbLeft =
      (scrollLeft / (contentWidth - containerWidth)) * maxThumbLeft || 0;
    thumb.style.left = thumbLeft + "px";
  }
}

if (typeof customElements.get("scroll-slider") == "undefined") {
  customElements.define("scroll-slider", ScrollSlider);
}
